import { app } from './app'

app.$mount('#app')


// WEBPACK FOOTER //
// ./src/index.js